var _path, _g, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClassRegistration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6045_3821)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6045_3821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 0.024L0 0V36H22.224V11.736L36 24.456V0.024Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6045_3821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.93555 26.004V6H32.0635V26.004",
    stroke: "black",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0716 29.9999H5.92764C3.71964 29.9999 1.93164 28.2119 1.93164 26.0039H34.0676C34.0676 28.2119 32.2796 29.9999 30.0716 29.9999Z",
    stroke: "black",
    strokeWidth: 2.25
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6439 34.8001L33.7319 33.8881L30.7079 26.9641H34.8119L25.8359 18.6721V30.8881L28.6199 27.8761L31.6439 34.8001Z",
    fill: "#E71D2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9751 22.0322C21.1629 22.0322 23.7471 19.3459 23.7471 16.0322C23.7471 12.7185 21.1629 10.0322 17.9751 10.0322C14.7873 10.0322 12.2031 12.7185 12.2031 16.0322C12.2031 19.3459 14.7873 22.0322 17.9751 22.0322Z",
    stroke: "black",
    strokeWidth: 2.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3494 16.0322L16.3574 13.0322V19.0322L21.3494 16.0322Z",
    fill: "#010101"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6045_3821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassRegistration);
export default __webpack_public_path__ + "static/media/class-registration.3595f103612a049e8511093ff5ae3472.svg";
export { ForwardRef as ReactComponent };